module.exports = __webpack_public_path__ + "media/assets/images/landings/workforce/workforce_logo_big-4487137d55aa846f2ccfe8deba9f4903.svg";